import Auth from '../services/auth';
import axios from 'axios';
import { API_ROOT } from './apiConfig';
const endpoint = `${API_ROOT}/api/Support`;
const auth = new Auth();


export const submitSupportRequest = async (supportRequestForm) => {
    const config = {
        headers: {
            "Authorization": `Bearer ${auth.getToken()}`
        }
    }
    return await axios.post(`${endpoint}`, supportRequestForm, config );
}



// WEBPACK FOOTER //
// ./src/services/supportService.js